<template>
  <v-app id="inspire" :class="{ watermark: isStaging }">
    <v-dialog v-model="loading" persistent width="400">
      <v-card color="primary" dark>
        <v-card-text class="pt-3 white--text">
          {{ message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-2 mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <NavMenu :class="{ watermarksm: isStaging }"></NavMenu>

    <AppBar :class="{ watermarksm: isStaging }"></AppBar>

    <v-main>
      <v-container class="pa-0" fluid>
        <router-view class="wrapper"></router-view>
      </v-container>
    </v-main>
    <v-dialog
      v-model="mfadialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <mfa-dialog></mfa-dialog>
    </v-dialog>
  </v-app>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js'
import NavMenu from '@/components/common/NavMenu'
import AppBar from '@/components/common/AppBar'
import MfaDialog from '@/components/EnrollMFADialog.vue'

export default {
  name: 'App',
  data() {
    return {
      showLoadingDialog: true,
      loading: false,
      message: 'Import in progress',
      mfadialog: false,
    }
  },
  props: {
    source: String,
  },
  components: {
    NavMenu,
    AppBar,
    MfaDialog,
  },
  computed: {
    isStaging() {
      return (
        process.env.NODE_ENV == 'staging' ||
        process.env.NODE_ENV == 'development'
      )
    },
  },
  created() {
    const vm = this
    EventBus.$on('isLoading', (val) => {
      vm.loading = val
    })

    EventBus.$on('toggleMFADialog', (val) => {
      vm.mfadialog = val
    })
  },
}
</script>

<style lang="scss">
.v-list-item--active {
  pointer-events: none;
}
</style>

<style>
.watermark {
  background: url('https://vonex.com.au/vonex/projects/watermark-blck.png')
    repeat fixed !important;
}
.watermarksm {
  background: url('https://vonex.com.au/vonex/projects/watermark-small.png')
    repeat !important;
}
.wrapper {
  width: 100%;
}
</style>
